import setUpConfig from '../config/general';
import getStatus from '../api/auth/getStatus';

export default function initApp(GlobalContext) {
	setUpConfig();
	let serverOrigin = GlobalContext.serverOrigin;
	let setUser = GlobalContext.setUser;
	let setUserLoading = GlobalContext.setUserLoading;
	getStatus(setUser, serverOrigin, setUserLoading);

	return <div>Hello?</div>;
}
